<template>
    <div style="background: url(/static/tp/logobj.jpg) no-repeat;
height:100%;
width:100%;
overflow: hidden;
background-size:cover;">
        <div style="margin-left: 10px;">
            <h1 class="title1 title2">汝州市第一人民医院大数据管理平台<br><br></h1>
           

            <div class="box"> <h3 class="title1" style="">欢迎登入</h3>
                <el-form :model="loginForm" status-icon :rules="rules" ref="ruleForm" label-width="60px"
                    class="demo-ruleForm el">
                    <el-form-item label="账号" prop="username">
                        <el-input type="text" v-model="loginForm.username"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input type="password" v-model="loginForm.password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                        <!-- <span>无账号—></span><router-link to="/register">注册</router-link> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
// import pubsub from 'pubsub-js'
export default {
    name: 'myLogin',
    data() {
        var validateUser = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入账号'));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        return {
            loginForm: {
                username: '',
                password: '',
            },
            // 表单验证规则
            rules: {
                username: [
                    { validator: validateUser, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            }
        };
    },
    beforeCreate() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.loginForm.username == 'rzsdyrmyy' && this.loginForm.password == '/RZSdyrmyy' + 1) {
                        sessionStorage.setItem('name1', this.loginForm.username),
                            this.$router.push({
                                path: '/rzsdyrmyy',
                            });
                    }else {
                        alert('账号或密码错误')
                    }
                    
                    // })
                } else {
                    console.log('error submit!!');
                    return false;
                }

                // if (valid) {
                //     // console.log('校验成功',this.loginForm);
                //     // this.$axios.get('http://127.0.0.1:8000/getcsrf/').then(res=>{
                //     // var csrftoken=res.data.csrftoken
                //     this.$axios
                //         .post(
                //             'http://127.0.0.1:8000/loginn/',//向loginn发送请求，验证密码是否正确
                //             {
                //                 'user': this.loginForm.username,
                //                 'password': this.loginForm.password,
                //             }
                //             // ,{
                //             //   headers:{
                //             //     'X-CSRFToken':csrftoken
                //             //   }
                //             // }
                //         ).then(res => {
                //             console.log(res.data.loginstatus);
                //             if (res.data.loginstatus == 1) //loginstatus为后端返回的数据，
                //             {
                //                 // this.$bus.$emit('hello',this.loginForm.username)
                //                 // this.$store.commit('username',this.loginForm.username)
                //                 sessionStorage.setItem('name1', this.loginForm.username),
                //                     this.$router.push({ //页面跳转到登录成功界面
                //                         path: './',
                //                         // query:{'username':JSON.stringify(this.loginForm.username)}
                //                     });
                //             }
                //             else {
                //                 alert('账号或密码错误')
                //             }
                //         })
                //     // })
                // } else {
                //     console.log('error submit!!');
                //     return false;
                // }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }

    }
}
</script>
<style scoped>
.title1 {
    color: #ff1122;
    font-size: 25px;
    text-align: center;
    margin-top: 35px;
    margin-left: 10px;
}

/* .title2 {
    color: #464444;
    text-shadow: 1px 1px 0 #ccc, 2px 2px 0 #ccc, 3px 3px 0 #ccc, 4px 4px 0 #ccc, 5px 5px 0 #ccc;
    font-size: 48px;
    font-weight: bold;
} */
.title2 {
    color: #88ccff; /* 深蓝色 */
    font-size: 60px;
    font-weight: bold;
    text-transform: uppercase;
    text-shadow: 
        2px 2px 0 #0d47a1, /* 第一层阴影 */
        4px 4px 0 #1565c0, /* 第二层阴影 */
        6px 6px 0 #1976d2, /* 第三层阴影 */
        8px 8px 0 #1e88e5, /* 第四层阴影 */
        10px 10px 0 #2196f3, /* 第五层阴影 */
        12px 12px 0 #64b5f6; /* 最外层阴影 */
    transition: transform 0.3s ease, text-shadow 0.3s ease;
}

.title2:hover {
    transform: translateY(-5px); /* 悬停时轻微上移 */
    text-shadow: 
        2px 2px 0 #0d47a1, 
        4px 4px 0 #1565c0, 
        6px 6px 0 #1976d2, 
        8px 8px 0 #1e88e5, 
        10px 10px 0 #2196f3, 
        12px 12px 0 #64b5f6,
        14px 14px 0 #90caf9; /* 悬停时增加一层阴影 */
}

.box {
    width: 380px;
    height: 300px;
    box-shadow: 0 0 10px 10px rgba(63, 63, 63, 0.4);
    background-color: rgba(255, 255, 255, 0.6);
    margin: 20px auto;
    /* margin-left: 100px; */
}

.el-form-item_label {
    color: black !important;
}

.el {
    padding: 20px 20px 0 0;
}
</style>